<template>
  <div class="scanningStock">
    <div class="head">
      <span>当前扫描箱码:</span>
      <el-input ref="input" v-model="scanningBox" @keyup.enter.native="scanning"></el-input>
      <el-button type="primary" size="small" @click="saveScanning">保存</el-button>
      <el-button type="primary" size="small" :loading="stockOut" @click="confirmStock">确定出库</el-button>
    </div>
    <div class="flex">
      <div class="main-left">
        <div class="title">当前扫描统计:</div>
        <div class="scanning">
          <div>
            <span>扫描完成主单数：</span><span class="green">{{main_number_count}}</span>
            <span class="right">扫描箱数：</span><span class="green">{{box_count}}</span>
          </div>
          <div>
            <span>扫描不完整主单：</span><span class="red">{{incomplete_count}}</span>
            <span class="right">待出库主单数：</span><span class="blue">{{wait_stock_count}}</span>
          </div>
        </div>
        <div class="title">扫描记录</div>
        <el-table :data="scanningTableData" :span-method="objectSpanMethod" border style="width: 100%">
          <el-table-column prop="main_number" label="主订单号" width="150">
          </el-table-column>
          <el-table-column prop="serial_number" label="编号" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.serial_number">{{scope.row.serial_number.split('-').slice(3).join('-')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="boxs" label="箱码" width="180">
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <i class="el-icon-circle-check" v-if="scope.row.status===true"></i>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="扫描时间" width="130">
          </el-table-column>
        </el-table>
      </div>
      <div class="main-right">
        <div class="title">
          日出库统计
          <!-- <span class="title">日出库统计</span> -->
          <el-input :disabled="true" v-model="currentDay"></el-input>
        </div>
        <div class="today-stock">
          <div>
            <span>今日出库主单数：</span><span class="green">{{current_stock_count}}</span>
            <span class="right">今日出库总箱数：</span><span class="green">{{current_box_count}}</span>
          </div>
        </div>
        <el-table v-loading="showCurrentTable" :data="completeTableData"  border style="width: 100%" height="600px">
          <el-table-column type="index" label="序号">
          </el-table-column>
          <!-- <el-table-column prop="created_at" label="日期">
          </el-table-column> -->
          <el-table-column prop="main_number" label="主订单号" width="160">
          </el-table-column>
          <el-table-column prop="serial_number" label="编号" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.serial_number">{{scope.row.serial_number.split('-').slice(3).join('-')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="box_num" label="出库箱数">
          </el-table-column>
          <el-table-column prop="oper_time" label="出库时间" width="130">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { listOrderWithBox, scanAction, getCurrentStockList, bigorderOutWare } from '@/models/orderModel'
const distinct = function (objArr) {
  const obj = {}
  const newObjArr = objArr.reduce((prev, curr) => {
    obj[curr.boxs] ? true : obj[curr.boxs] = true && prev.push(curr)
    return prev
  }, [])
  console.log(newObjArr)
  return newObjArr
}
// const distinct = function (data) {
//   // let arr = a.concat(b)
//   let arr = [...data]
//   for (let i = 0, len = arr.length; i < len; i++) {
//     for (let j = i + 1; j < len; j++) {
//       if (arr[i].boxs === arr[j].boxs) {
//         if (arr[i].time > arr[j].time) {
//           arr.splice(j, 1)
//         }
//         if (arr[i].time < arr[j].time) {
//           arr.splice(i, 1)
//         }
//         // splice 会改变数组长度，所以要将数组长度 len 和下标 j 减一
//         len--
//         j--
//       }
//     }
//   }
//   return arr
// }
export default {
  data () {
    return {
      isZhifaOrFactory: true,
      scanningBox: '',
      main_number_count: 0,
      box_count: 0,
      incomplete_count: 0,
      wait_stock_count: 0,
      current_stock_count: 0,
      current_box_count: 0,
      scanningTableData: [],
      initialData: [],
      completeTableData: [],
      currentDay: '',
      showCurrentTable: true,
      completeOrderIds: '',
      scanningData: [],
      stockOut: false
    }
  },
  mounted () {
    let currentDate = new Date()
    let year = currentDate.getFullYear()
    let month = currentDate.getMonth() + 1
    let day = currentDate.getDate()
    this.currentDay = year + '-' + month + '-' + day
    this.getScanningTable()
    this.getCurrentStockList()
    this.$refs['input'].focus()
  },
  methods: {
    async confirmStock () {
      this.stockOut = true;
      let params = {
        ids: this.completeOrderIds
      }
      if (this.completeOrderIds) {
        let data = await bigorderOutWare(params)
        if (data.message === 'Success') {
          this.stockOut = false;
          this.completeOrderIds = ''
        }else{
          this.stockOut = false;
        }
        this.getCurrentStockList()
      } else {
        this.$message.warning('未扫描箱码')
        this.stockOut = false;
      }
      this.getScanningTable()
    },
    // 获取备货完成订单
    async getCurrentStockList () {
      this.current_box_count = 0
      this.showCurrentTable = true
      let params = {
        date: this.currentDay
      }
      let data = await getCurrentStockList(params)
      setTimeout(() => {
        this.showCurrentTable = false
      }, 300)
      this.completeTableData = data.data
      this.current_stock_count = data.data.length
      for (let i of data.data) {
        this.current_box_count = this.current_box_count + parseInt(i.box_num)
      }
    },
    // 扫描
    scanning () {
      let data = this.scanningTableData.filter(item => item.boxs === this.scanningBox)
      // let scanningData = []
      if (data.length !== 0) {
        for (let i of this.scanningTableData) {
          if (i.boxs === this.scanningBox) {
            i.status = true
            i.time = this.getCurrentDate(2)
            this.$message.success('扫描成功')
            this.$refs['input'].focus()
          }
          if (i.status === true) {
            this.scanningData.unshift({id: i.id, boxs: i.boxs, time: i.time})
          }
        }
      } else {
        this.$message.warning('无此箱码')
        this.$refs['input'].focus()
      }
      this.scanningBox = ''
      // let scanningData = this.scanningData
      this.scanningData = this.$set(this.$data, 'scanningData', distinct(this.scanningData))
      localStorage.setItem('bigorderscanningData', JSON.stringify(this.scanningData))
      this.getScanningTable()
    },
    getCurrentDate (format) {
      let now = new Date()
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth()// 得到月份
      let date = now.getDate()// 得到日期
      let hour = now.getHours()// 得到小时
      let minu = now.getMinutes()// 得到分钟
      let sec = now.getSeconds()// 得到秒
      month = month + 1
      if (month < 10) month = '0' + month
      if (date < 10) date = '0' + date
      if (hour < 10) hour = '0' + hour
      if (minu < 10) minu = '0' + minu
      if (sec < 10) sec = '0' + sec
      let time = ''
      // 精确到天
      if (format === 1) {
        time = year + '-' + month + '-' + date
      } else if (format === 2) { // 精确到分
        time = year + '-' + month + '-' + date + ' ' + hour + ':' + minu + ':' + sec
      }
      return time
    },
    // 保存
    async saveScanning () {
      let orderNoList = []
      this.box_count = 0
      for (let i of this.scanningTableData) {
        if (i.status === true) {
          this.box_count++
        } else {
          orderNoList.push(i.id)
        }
      }
      let newOrderNoList = this.removeDuplicatedItem(orderNoList)
      this.main_number_count = this.initialData.length - newOrderNoList.length
      this.incomplete_count = newOrderNoList.length
      let completeOrderList = this.initialData.filter(function (item) { // 获得扫描完成订单
        return orderNoList.indexOf(item.id) === -1
      })
      let ids = ''
      console.log(orderNoList, this.initialData, completeOrderList, 'ddd')
      if (completeOrderList.length !== 0) {
        for (let i = 0; i < completeOrderList.length; i++) {
          if (ids === '') {
            ids = ids + completeOrderList[i].id
          } else {
            ids = ids + ',' + completeOrderList[i].id
          }
        }
        let params = {
          ids: ids
        }
        this.completeOrderIds = ids
        let data = await scanAction(params)
        if (data.message === 'Success') {
          this.$message.success('保存成功')
        }
      } else {
        this.$message.warning('无扫描完成订单')
      }
    },
    // 数组去重
    removeDuplicatedItem (arr) {
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i] === arr[j]) {
            arr.splice(j, 1)
            j--
          }
        }
      }
      return arr
    },
    // 获取未扫描订单
    async getScanningTable () {
      this.initialData = await listOrderWithBox()
      this.wait_stock_count = this.initialData.length
      this.scanningTableData = this.changeScanningData(this.initialData)
      let data = JSON.parse(localStorage.getItem('bigorderscanningData'))
      if (data) {
        for (let i of data) {
          for (let j of this.scanningTableData) {
            if (i.boxs === j.boxs) {
              j.status = true
              j.time = i.time
            }
          }
        }
        // let orderNoList = []
        // this.box_count = 0
        // for (let i of this.scanningTableData) {
        //   if (i.status === true) {
        //     this.box_count++
        //   } else {
        //     orderNoList.push(i.id)
        //   }
        // }
        // let newOrderNoList = this.removeDuplicatedItem(orderNoList)
        // this.main_number_count = this.initialData.length - newOrderNoList.length
        // this.incomplete_count = newOrderNoList.length
      }
    },
    changeScanningData (data) {
      let newArray = []
      for (let i of data) {
        for (let j = 0; j < i.boxs.length; j++) {
          newArray.push({
            id: i.id,
            main_number: i.main_number,
            serial_number: i.serial_number,
            boxs: i.boxs[j],
            count: j === 0 ? i.boxs.length : 0,
            status: false
          })
        }
      }
      return newArray
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log(row)
      if (columnIndex === 0 || columnIndex === 1) {
        if (row.count !== 0) {
          return {
            rowspan: row.count,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
.scanningStock {
  .red {
    color:#f61c1b;
  }
  .blue {
    color:#4473f4;
  }
  i,.green {
    color:#20bd3c;
  }
  .red,.green,.blue {
    font-size:40px;
    line-height: 28px;
  }
  .el-input.is-disabled .el-input__inner {
    color:#606266;
  }
  .head {
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 10px;
    .el-input {
      width: 200px;
      margin-top: 8px;
      margin-left: 10px;
      margin-right: 20px;
    }
    .el-input__inner {
      height: 30px;
    }
  }
  .main-left {
    margin-right: 15px;
    .title {
      font-weight: bold;
      height: 50px;
      line-height: 50px;
    }
    .scanning {
      font-weight: bold;
      padding:20px 15px;
      height: 80px;
      background-color: rgb(248, 248, 248);
      div {
        display: flex;
        align-items: center;
        .right {
          margin-left: 30px;
        }
      }
      div:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
  .main-right {
    // position: fixed;
    // left: 660px;
    // top: 136px;
    margin-left: 15px;
    .title {
      font-weight: bold;
      font-size: 16px;
      // margin-top: 10px;
      height: 50px;
      line-height: 50px;
      // margin-bottom: 10px;
      display: inline-block;
    }
    .el-input {
      width: 160px;
    }
    .el-input__inner {
      height: 30px;
    }
    .today-stock {
      padding: 20px;
      height: 80px;
      line-height: 80px;
      font-weight: bold;
      // margin-left: 20px;
      // margin-right: 20px;
      background-color: rgb(248, 248, 248);
      div {
        display: flex;
        align-items: center;
        .right {
          margin-left: 80px;
        }
      }
    }
    .el-table{
      margin-top: 50px;
    }
  }
  .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding: 0;
  }
}
.flex{
  display: flex;
  align-items: stretch;
  div{
    flex: 1;
  }
  // justify-content:space-between;
}
</style>



// WEBPACK FOOTER //
// src/pages/bigorder/scanningStock.vue